import { Koi } from '@ksyos/koi';

export const relationNumberSchema = Koi.string().max(7).min(4).allow(null).optional().numeric();
export const relationNumberExistsSchema = Koi.boolean();
